module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.37942120.png";